export const ALERT_TYPE_MAPPING = {
  1: "Water Overconsumption",
  2: "Chemical Overconsumption",
  3: "Excessive Drain Discharge",
  5: "Duration Exceeded",
  7: "Pre-Rinse Overuse",
  70: "Post-Rinse Flow Issue",
  71: "Return Flow Issue",
  72: "Sequence Anomaly",
  73: "Supply Temperature Low",
  74: "Return Temperature Low",
  75: " Supply Volume Exceeds Return",
  76: "Conductivity Out of Range",
  80: "Unclassified",
  99: "Process Interruption",
};

export const ALERT_COLORS = {
  70: "#10B981", // Emerald
  71: "#F97316", // Orange
  72: "#EC4899", // Pink
  73: "#6366F1", // Indigo
  74: "#84CC16", // Lime
  75: "#F43F5E", // Rose
  76: "#8B5CF6", // Violet
  99: "#0EA5E9", // Sky Blue
  80: "#14B8A6", // Teal Blue
};
